import React, { useEffect, useState } from "react";
import loginImage01 from "../../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../../assets/images/registration/registration-steps-image-04.jpg";
import { languages, raceEthnicities } from "../../../Common/MasterData";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';

import { updateUserData } from '../../../Redux/userReducer';
import { Endpoints } from "../../../Global/Endpoints";
import CustomDropdown from "../../../CustomControls/dropdown";


const UpdatePhoneNumber = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const contract = useSelector((state) => state.userData);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [country, setCountry] = useState(null);
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    dateOfBirth: "",
    phoneNumber: "",
    agreeToTexts: false,
    language: "",
    raceEthnicity: "",
    preferredName: "",
    gender: "",
    relationshipStatus: "",
    pronouns: "",
    goal: "",
    FirstName: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch("https://ipinfo.io/json");
        const data = await response.json();
        setCountry(data.country);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCountry();
  }, []);

  useEffect(() => {
    if (contract.userData) {
      const languageValue = languages.find(lang =>
      lang.label === contract.userData.Language || lang.value === contract.userData.Language
    )?.label || "";
      const ethnicityValue = raceEthnicities.find(race => 
        race.label === contract.userData.Ethnicity || race.value === contract.userData.Ethnicity
      )?.value || "";

      setFormData({
        FirstName: contract.userData.FirstName || "",
        dateOfBirth: contract.userData.DOB || "",
        phoneNumber: contract.userData.MobileNumber || contract.userData.PhoneNo,
        agreeToTexts: contract.userData.TextNotificationStatus === "Yes",
        language: languageValue,
        raceEthnicity: contract.userData.Country === "Canada" ? "" : ethnicityValue,
        preferredName: contract.userData.PreferredName || "",
        gender: contract.userData.Gender || "",
        relationshipStatus: contract.userData.RelationshipStatus || "",
        pronouns: contract.userData.Pronouns || "",
        goal: contract.userData.Goal || ""
      });
    }
  }, [contract.userData]);
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === "phoneNumber") {
    // Only allow digits
    const numericValue = value.replace(/\D/g, "");
    setFormData({
      ...formData,
      [id]: numericValue,
    });
  } else {
    const updatedFormData = {
      ...formData,
      [id]: value,
    };
    setFormData(updatedFormData);
  }
};

  const isValidForm = () => {
    let formErrors = {};
    if (!formData.phoneNumber.trim()) formErrors.phoneNumber = t('phonenumberrequired');

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevent double submit
    setIsSubmitting(true);
    if (isValidForm()) {
      debugger
      const updatedData = {
        FirstName: contract.userData.FirstName || "",
        LastName: contract.userData.LastName || "",
        PreferredName: contract.userData.PreferredName,
        EmailID: contract.userData.EmailID || "",
        PWD: contract.userData.PWD || "",
        ConfirmPassword: contract.userData.ConfirmPassword || "",
        AgreeTerms: contract.userData.AgreeTerms || false,
        Country: country,
        Language: formData.language || "",
        Ethnicity: contract.userData.Country === "Canada" ? "" : formData.raceEthnicity || "",
        PhoneNo: formData.phoneNumber || "",
        DOB: contract.userData.DOB || "",
        TextNotificationStatus: contract.userData.TextNotificationStatus || "No",
        Version: "10.8",
        AppLanguage: contract.userData.AppLanguage || "English",
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        Company: contract.userData.Company || "",
        MemberID: contract.userData.MemberID || "",
        WhyHere: contract.userData.WhyHere || "",
        WINBenefits: "Y",
        Promocode: contract.userData.EmployerCode,
        Pronouns: contract.userData.Pronouns,
        UpdateFlag: "Y",
        JourneyStatus: contract.userData.JourneyStatus || "",
        HealthPlanId: contract.userData.HealthPlanId || "",
        RelationshipStatus: contract.userData.RelationshipStatus,
        IsHealthProfileCompleted: 1,
        BenefitProvider: contract.userData.BenefitProvider,
        SubscriberID: contract.userData.SubscriberID || "",
        Gender: contract.userData.Gender,
        Contract: contract.userData.ContractIdentified || contract.userData.Contract,
        SecureCode: contract.userData.SecureCode,
        Goal: contract.userData.Goal,
        CountryCode: contract.userData.CountryCode,
      };

console.log("Updated Data Payload:", updatedData); // Debug log to check the payload
      try {
        const response = await axios.post(
          Endpoints.CreateAccount,
          `_Params=${encodeURIComponent(JSON.stringify(updatedData))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            }
          }
        );
        if (response.data.Result === 2) {
          // Dispatch the action to update user data in the Redux store
          debugger
          dispatch(updateUserData(response.data)); 
          toast.success(t('phonenumberupdate'));
                 // Reset header menu state before navigating home
                 window.dispatchEvent(new Event("resetHeaderMenu"));
      
          // Set a delay of 2 seconds before navigating to the home page
          setTimeout(() => {
            navigate("/home");
          }, 2000); // 2000 milliseconds = 2 seconds
        } else if (response.data.Result === 0) {
          navigate("/registration-error");
        } else {
          toast.error(response.data.Message || t('updatefailed'));
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error(t('erroroccuredupdatephonenumber'));
        setIsSubmitting(false); // Allow retry on failure
      }
    }
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);
const capitalizeFirstLetter = (name) => {
  if (!name) return ''; // If no name is provided, return an empty string
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(); // Capitalize first letter and lowercase the rest
};

console.log("Form Data:", formData);

  return (
    <>
      <div className="registration-block-main">
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="registration-form-main">
          <div className="registration-form">
            <h3 className="page-heading-secondary-black">{t('nicetomeetyou')}</h3>
            <div className="page-heading-bold">
   {capitalizeFirstLetter(formData.preferredName || formData.FirstName)}
</div>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="dateOfBirth" className="form-label win-form-label mandatory">{t('dateofbirth')}</label>
                <DatePicker
                  selected={formData.dateOfBirth ? new Date(formData.dateOfBirth) : null}
                  disabled
                  className="form-control win-form-control calendar-control mobile-view"
                />
              </div>

              <div className="mb-3">
                <label htmlFor="phoneNumber" className="form-label win-form-label mandatory">{t('phonenumber')}</label>
                <input
                  type="text"
                  className="form-control win-form-control mobile-view"
                  id="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                />
                {errors.phoneNumber && <div className="form-field-error-message">{errors.phoneNumber}</div>}
              </div>

              <div className="mb-3">
                <label htmlFor="language" className="form-label win-form-label mandatory">{t('language')}</label>
                <CustomDropdown
                options={languages.map(lang => lang.label)}
                selectedOption={
                  formData.language || ""
                }
                 onChange={(label) => {
                  setFormData(prev => ({
                    ...prev,
                    language: label
                  }));
                }}
                placeholder={t('selectlanguage')}
                searchable={true}
              />
              </div>

              {contract.userData.Country !== "Canada" && (
              <div className="mb-3">
                <label htmlFor="raceEthnicity" className="form-label win-form-label mandatory">{t('ethncity')}</label>
                <CustomDropdown
                options={raceEthnicities.map((race) => race.label)}
                selectedOption={
                  raceEthnicities.find(r => r.value === formData.raceEthnicity)?.label || ""
                }
                onChange={(label) => {
                  const selectedRace = raceEthnicities.find(r => r.label === label);
                  setFormData((prev) => ({
                    ...prev,
                    raceEthnicity: selectedRace?.value || "",
                  }));

                  setErrors((prev) => ({
                    ...prev,
                    raceEthnicity: "",
                  }));
                }}
                placeholder={t('raceethncity')}
                searchable={true}
              />
              </div>
              )}

              <div className="mb-3 mt-4">
                <button className="win-btn-primary mobile-view" type="submit"   disabled={isSubmitting}>
                  {t('Submit')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default UpdatePhoneNumber;
